/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DocumentDto } from '../models/document-dto';
import { fixDocumentControllerAddEtcDocument } from '../fn/fix-document/fix-document-controller-add-etc-document';
import { FixDocumentControllerAddEtcDocument$Params } from '../fn/fix-document/fix-document-controller-add-etc-document';
import { fixDocumentControllerAiTest } from '../fn/fix-document/fix-document-controller-ai-test';
import { FixDocumentControllerAiTest$Params } from '../fn/fix-document/fix-document-controller-ai-test';
import { fixDocumentControllerFindByTicketId } from '../fn/fix-document/fix-document-controller-find-by-ticket-id';
import { FixDocumentControllerFindByTicketId$Params } from '../fn/fix-document/fix-document-controller-find-by-ticket-id';
import { fixDocumentControllerFindEtcDocuments } from '../fn/fix-document/fix-document-controller-find-etc-documents';
import { FixDocumentControllerFindEtcDocuments$Params } from '../fn/fix-document/fix-document-controller-find-etc-documents';
import { fixDocumentControllerUpdate } from '../fn/fix-document/fix-document-controller-update';
import { FixDocumentControllerUpdate$Params } from '../fn/fix-document/fix-document-controller-update';
import { TestDto } from '../models/test-dto';

@Injectable({ providedIn: 'root' })
export class FixDocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fixDocumentControllerFindByTicketId()` */
  static readonly FixDocumentControllerFindByTicketIdPath = '/api/fix-document';

  /**
   * 진행 전 문서 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixDocumentControllerFindByTicketId()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixDocumentControllerFindByTicketId$Response(params: FixDocumentControllerFindByTicketId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentDto>>> {
    return fixDocumentControllerFindByTicketId(this.http, this.rootUrl, params, context);
  }

  /**
   * 진행 전 문서 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fixDocumentControllerFindByTicketId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixDocumentControllerFindByTicketId(params: FixDocumentControllerFindByTicketId$Params, context?: HttpContext): Observable<Array<DocumentDto>> {
    return this.fixDocumentControllerFindByTicketId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentDto>>): Array<DocumentDto> => r.body)
    );
  }

  /** Path part for operation `fixDocumentControllerUpdate()` */
  static readonly FixDocumentControllerUpdatePath = '/api/fix-document';

  /**
   * 문서 업데이트
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixDocumentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fixDocumentControllerUpdate$Response(params: FixDocumentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return fixDocumentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 업데이트
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fixDocumentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fixDocumentControllerUpdate(params: FixDocumentControllerUpdate$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.fixDocumentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

  /** Path part for operation `fixDocumentControllerFindEtcDocuments()` */
  static readonly FixDocumentControllerFindEtcDocumentsPath = '/api/fix-document/etc';

  /**
   * 기타 치료 문서 조회
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixDocumentControllerFindEtcDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixDocumentControllerFindEtcDocuments$Response(params: FixDocumentControllerFindEtcDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentDto>>> {
    return fixDocumentControllerFindEtcDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * 기타 치료 문서 조회
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fixDocumentControllerFindEtcDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixDocumentControllerFindEtcDocuments(params: FixDocumentControllerFindEtcDocuments$Params, context?: HttpContext): Observable<Array<DocumentDto>> {
    return this.fixDocumentControllerFindEtcDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentDto>>): Array<DocumentDto> => r.body)
    );
  }

  /** Path part for operation `fixDocumentControllerAiTest()` */
  static readonly FixDocumentControllerAiTestPath = '/api/fix-document/ai-test';

  /**
   * AI 테스트
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixDocumentControllerAiTest()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixDocumentControllerAiTest$Response(params?: FixDocumentControllerAiTest$Params, context?: HttpContext): Observable<StrictHttpResponse<TestDto>> {
    return fixDocumentControllerAiTest(this.http, this.rootUrl, params, context);
  }

  /**
   * AI 테스트
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fixDocumentControllerAiTest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fixDocumentControllerAiTest(params?: FixDocumentControllerAiTest$Params, context?: HttpContext): Observable<TestDto> {
    return this.fixDocumentControllerAiTest$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestDto>): TestDto => r.body)
    );
  }

  /** Path part for operation `fixDocumentControllerAddEtcDocument()` */
  static readonly FixDocumentControllerAddEtcDocumentPath = '/api/fix-document/add-etc';

  /**
   * 기타 문서 추가
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fixDocumentControllerAddEtcDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fixDocumentControllerAddEtcDocument$Response(params: FixDocumentControllerAddEtcDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
    return fixDocumentControllerAddEtcDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * 기타 문서 추가
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fixDocumentControllerAddEtcDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fixDocumentControllerAddEtcDocument(params: FixDocumentControllerAddEtcDocument$Params, context?: HttpContext): Observable<DocumentDto> {
    return this.fixDocumentControllerAddEtcDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentDto>): DocumentDto => r.body)
    );
  }

}
